// Import Swiper
import Swiper from 'swiper/bundle';

// Initialize Related Pages Carousel
$('.pattern-related-pages').each(function() {
  let self = $(this);
  let swiperContainer = self.find('.swiper');

  if (swiperContainer.length === 0) return;

  let carouselId = swiperContainer.attr('class').split(' ')[1];

  new Swiper('.' + carouselId, {
    slidesPerView: 1.2,
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next-' + carouselId,
      prevEl: '.swiper-button-prev-' + carouselId,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });
});
